import React, { useEffect, useState } from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Avatar from '@material-ui/core/Avatar';
import RoomOutlinedIcon from '@material-ui/icons/RoomOutlined';
import { useParams, useHistory } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import { getUserById, getUserDetailsById, getUserOrdersById } from '../../actions/users';
import { USER_ACTIVE_ORDERS, USER_ORDERS_HISTORY } from '../../constants';
import Loader from '../common/Loader';
import moment from 'moment';
import { CsvBuilder } from 'filefy';

import tableConfig, { data } from './config';
import Button from '../common/Button';
import Table from '../common/Table';

const Profile = props => {
    const { classes } = props;
    const history = useHistory();
    const config = tableConfig(props);
    const params = useParams();
    const userId = params.id;
    const [userdet, setUserDet] = useState([]);
    const [userOrders, setUserOrders] = useState([]);
    const [msg, setMsg] = useState('');
    const [msgstatus, setMsgStatus] = useState();

    // const [buyerstatistics, setBuyerStatistics] = useState([]);

    const onView = () => {
        console.log('View');
    };
    const onDelete = () => {
        console.log('Delete');
    };

    useEffect(() => {
        fetchUserData();
    }, []);

    const fetchUserData = async () => {
        try {
            const userRes = await getUserDetailsById(userId);
            console.log({
                userRes
            });

            if (userRes && userRes.data) {
                setMsgStatus(userRes.data.status);
                setMsg(userRes.data.ResponseText);
                setUserDet(userRes.data.ResponseData ? userRes.data.ResponseData : '');
            }
        } catch (error) {
            console.log(error);
        }
    };

    const exportCsv = (columns, data) => {
        const columnTitles = columns.map(columnDef => columnDef.title);
        const csvExportData = []
        const orderFileds = [
            { name: 'invoice_id', subField: "" },
            { name: 'order_date_system', subField: "" },
            { name: 'food_seller', subField: "business_name" },
            { name: 'net_amount', subField: "" },
            { name: 'order_payment', subField: "payment_status" },
            { name: 'order_status', subField: "" },
        ]

        const ordersData = data.map(order => {
            const ordersDataDetails = []
            const orderData = orderFileds.map((orderFiled) => {
                let orderValue = order[orderFiled.name]
                if (orderFiled.subField && orderValue) {
                    orderValue = order[orderFiled.name] && order[orderFiled.name][orderFiled.subField]
                }

                if (orderFiled.name === "order_date_system") {
                    return moment.utc(orderValue).local().format("DD-MM-YYYY h:mm:ss a")
                }
                return orderValue
            })

            ordersDataDetails.push(...orderData)
            return ordersDataDetails
        })

        csvExportData.push(...(ordersData || []))
        const builder = new CsvBuilder(`user-orders.csv`)
            .setColumns(columnTitles)
            .addRows(csvExportData);

        builder.exportFile()

        return builder;
    }

    // let ss = userdet.buyerStatistics[0];
    // console.log("firstApp",Object.keys(userdet.buyerStatistics)[0]);
    console.log('userDet------', userdet);
    // console.log('userDet locality------', userdet.locality);
    return (
        <div style={{ width: '100%' }}>
            {/* <Box display="flex" p={1} className="mb-3" justifyContent="flex-end">
                <Button
                    onClick={() => {
                        history.goBack();
                    }}
                    size="small"
                    label="Back"
                ></Button>
            </Box> */}
            <React.Fragment>
                {msgstatus !== 200 && (
                    <div className={classes.errorwrap}>
                        <h1>{msg}</h1>
                    </div>
                )}
                {msgstatus !== 200 && userdet.length === 0 && <Loader />}

                <div className={classes.wrap}>
                    <div className={classes.section1}>
                        {userdet !== '' &&
                            userdet.map((uDate, index) => {
                                return (
                                    <Card className={classes.root} key={index}>
                                        <CardContent>
                                            <div className={classes.cardContent}>
                                                <Avatar
                                                    alt="Remy Sharp"
                                                    src={uDate.dpUrl}
                                                    className={classes.profile}
                                                />
                                                <h2>
                                                    <strong> {uDate.name ? uDate.name : ''} </strong>
                                                </h2>
                                            </div>
                                            <div className={classes.profileDetails}>
                                                <div className={classes.item1}>
                                                    <label> Email </label>
                                                    <label>
                                                        <strong>
                                                            {uDate.email_id ? uDate.email_id : ''}
                                                        </strong>
                                                    </label>
                                                </div>
                                                <div className={classes.item1}>
                                                    <label> Phone Number </label>
                                                    <label>
                                                        <strong>
                                                            {uDate.email_id ? uDate.mobile_no : ''}
                                                        </strong>
                                                    </label>
                                                </div>
                                                <div className={classes.item1}>
                                                    <label> Address </label>
                                                    <label>
                                                        <strong>
                                                            {uDate.address_line1 ? uDate.address_line1 + ", " : ''}
                                                            {uDate.city ? uDate.city.city_name + ", " : ''}
                                                            {uDate.state ? uDate.state.state_name + ", " : ''}
                                                            {uDate.country ? uDate.country.country_name + " - " : ''}
                                                            {uDate.pin_code ? uDate.pin_code : ''}
                                                        </strong>
                                                        <RoomOutlinedIcon />
                                                    </label>
                                                </div>
                                                <div className={classes.item1}>
                                                    <label> Created Date </label>
                                                    <label>
                                                        <strong>
                                                            <div>
                                                                <span className='mr-2'>{moment.utc(uDate.created_date).local().format("DD-MM-YYYY")}</span>
                                                                <span className='mr-2'>{moment.utc(uDate.created_time, "h:mm:ss a").local().format("h:mm:ss a")}</span>
                                                            </div>
                                                        </strong>
                                                    </label>
                                                </div>
                                            </div>
                                        </CardContent>
                                    </Card>
                                );
                            })}
                    </div>
                    <div className={classes.section2}>
                        {userdet != '' && (
                            <div>
                                <div>
                                    <h5 className={classes.heading}> Active Orders </h5>
                                    <Table
                                        tableConfig={config}
                                        data={data}
                                        // onView={onView}
                                        // onDelete={onDelete}
                                        noBorder
                                        apidata="userordersactive"
                                        url={`${USER_ACTIVE_ORDERS.replace(":userId", userId)}`}
                                        extraQueryParam={["order_status=PENDING"]}
                                        exportCsv={exportCsv}
                                    />
                                </div>
                                <div className={classes.orderHistory}>
                                    <h5 className={classes.heading}> Order History </h5>
                                    <Table
                                        tableConfig={config}
                                        data={data}
                                        // onView={onView}
                                        // onDelete={onDelete}
                                        noBorder
                                        apidata="userordershistory"
                                        url={`${USER_ACTIVE_ORDERS.replace(":userId", userId)}`}
                                        extraQueryParam={["order_status=SUCCESS"]}
                                        exportCsv={exportCsv}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </React.Fragment>
        </div>
    );
};

export default Profile;
